var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.566,
    height: 14.819,
    viewBox: "0 0 15.566 14.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-02",
    transform: "translate(-86.2 -92.9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 3.741,
    cy: 3.741,
    r: 3.741,
    transform: "translate(90.242 92.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M93.984,230.6c4.3,0,7.784.1,7.784,4.4v1.975H86.2V235C86.2,230.7,89.684,230.6,93.984,230.6Z",
    transform: "translate(0 -129.254)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.f26ff65630cef55492bf5664b0f03aa6.svg";
export { ForwardRef as ReactComponent };